import { render, staticRenderFns } from "./DetailPageRepairList.vue?vue&type=template&id=2d7c28d3&scoped=true"
import script from "./DetailPageRepairList.vue?vue&type=script&lang=js"
export * from "./DetailPageRepairList.vue?vue&type=script&lang=js"
import style0 from "./DetailPageRepairList.vue?vue&type=style&index=0&id=2d7c28d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7c28d3",
  null
  
)

export default component.exports